// Firma kargo takibi (Stok Yönetimi › Kargo Takip ve Profil › Kargolarım).
// Kayıtlarda saklanan değerler (yön, durum, firma kodu) değişmez; burada
// yalnızca ekrandaki metinler var.
const cargo = {
  titleCompany: 'Kargo Takip',
  subtitleCompany: 'Firmaya gelen ve firmadan giden tüm kargolar. Bir satıra dokunarak ayrıntıları açın, durumu tek dokunuşla güncelleyin.',
  helpPersonal: '"Kargo Gönder" ile firmadan çıkan, "Kargo Al" ile size gelecek bir kargoyu kaydedin. Durumu güncelledikçe kargoya bağlı stok kalemleri stoğa otomatik işlenir.',
  actions: {
    access: 'Yetkiler',
    receive: 'Kargo Al',
    send: 'Kargo Gönder',
  },
  stats: {
    label: 'Kargo özeti ve hızlı filtre',
    all: 'Toplam',
    incoming: 'Gelen',
    outgoing: 'Giden',
    inTransit: 'Yolda',
    overdue: 'Geciken',
    cost: 'Kargo Bedeli',
    costShort: 'Bedel',
  },
  search: 'Konu, kişi, kurum veya takip numarası ara...',
  loading: 'Kargolar yükleniyor',
  loadError: 'Kargo kayıtları yüklenemedi. Lütfen sayfayı yenileyin.',
  count_one: '{{count}} kargo',
  count_other: '{{count}} kargo',
  empty: {
    noneTitle: 'Henüz kargo kaydı yok',
    noneText: '"Kargo Gönder" veya "Kargo Al" ile ilk kaydı oluşturun.',
    noMatchTitle: 'Eşleşen kargo bulunamadı',
    noMatchText: 'Arama ifadesini veya filtreyi değiştirmeyi deneyin.',
    clearFilters: 'Filtreyi temizle',
  },
  direction: {
    incoming: {
      label: 'Gelen Kargo',
      short: 'Gelen',
      description: 'Firmamıza gönderilen, teslim alınacak kargo',
      party: 'Gönderen',
      partyName: 'Gönderen Adı',
      address: 'Çıkış Adresi',
    },
    outgoing: {
      label: 'Giden Kargo',
      short: 'Giden',
      description: 'Firmamızdan gönderilen kargo',
      party: 'Alıcı',
      partyName: 'Alıcı Adı',
      address: 'Teslimat Adresi',
    },
  },
  status: {
    incoming: {
      not_sent: 'Bekleniyor',
      shipped: 'Yolda',
      delivered: 'Teslim Alındı',
      returned: 'İade / Sorunlu',
    },
    outgoing: {
      not_sent: 'Hazırlanıyor',
      shipped: 'Kargoya Verildi',
      delivered: 'Teslim Edildi',
      returned: 'İade / Sorunlu',
    },
  },
  overdue: 'Gecikti',
  carriers: {
    kurye: 'Kurye / Elden Teslim',
    diger: 'Diğer',
  },
  list: {
    owner: 'Kayıt: {{name}}',
    items_one: '{{count}} stok kalemi bağlı',
    items_other: '{{count}} stok kalemi bağlı',
    files_one: '{{count}} dosya',
    files_other: '{{count}} dosya',
    noCarrier: 'Firma seçilmedi',
    dates: {
      delivered: 'Teslim',
      expected: 'Beklenen',
      shipped: 'Gönderim',
    },
  },
  toast: {
    added: 'Kargo kaydı eklendi',
    updated: 'Kargo kaydı güncellendi',
    saveError: 'Kargo kaydı kaydedilemedi',
    statusChanged: 'Durum "{{status}}" olarak güncellendi',
    statusError: 'Durum güncellenemedi',
    deleted: 'Kargo kaydı silindi',
    deleteError: 'Kargo kaydı silinemedi',
    copied: 'Takip numarası kopyalandı',
    copyError: 'Kopyalanamadı',
    waitUpload: 'Dosya yüklemesi bitene kadar bekleyin',
    unsupported: '{{name}}: desteklenmeyen dosya türü',
    tooLarge: '{{name}}: dosya 10 MB sınırını aşıyor',
    uploadError: 'Dosya yüklenirken bir hata oluştu',
    staffError: 'Çalışan listesi yüklenemedi',
    accessGranted: '{{name}}: kargo yetkisi verildi',
    accessRevoked: '{{name}}: kargo yetkisi kaldırıldı',
    accessError: 'Yetki güncellenemedi',
  },
  confirmDelete: {
    title: 'Kargo kaydı silinsin mi?',
    message: '"{{subject}}" kargo kaydı kalıcı olarak silinecek.',
    stockNote: 'Stoğa işlenen miktarlar geri alınır.',
    confirm: 'Evet, sil',
    cancel: 'Vazgeç',
  },
  form: {
    titleNew: 'Yeni Kargo Kaydı',
    titleEdit: 'Kargo Kaydını Düzenle',
    subtitle: 'Yıldızlı alanlar zorunlu; diğerlerini kargo ilerledikçe doldurabilirsiniz.',
    directionLabel: 'Kargonun yönü',
    sections: {
      shipment: 'Gönderi',
      shipmentHint: 'Kargoyu listede kolayca bulmanızı sağlayacak kısa bir başlık yazın.',
      status: 'Durum ve Kargo Bilgileri',
      party: 'Karşı taraf',
      partyHint: 'Kargoyu kimin gönderdiği / kime gideceği. Telefon, sorun çıkarsa hızlıca ulaşmak içindir.',
      items: 'Stok Kalemleri',
      files: 'Dosyalar ve Not',
      filesHint: 'Kargo fişi, irsaliye veya teslim tutanağının fotoğrafını ekleyin; kayıtla birlikte saklanır.',
    },
    subject: 'Konu Başlığı',
    subjectPlaceholder: 'Örn. Tedarikçiden lab kiti sevkiyatı',
    content: 'İçerik',
    contentPlaceholder: 'Kutuda ne var? Malzeme, adet, lot numarası...',
    statusHint: 'Durumu seçtiğinizde gönderim ve teslim tarihleri otomatik dolar; dilerseniz değiştirebilirsiniz.',
    carrier: 'Kargo Firması',
    carrierPlaceholder: 'Seçiniz...',
    tracking: 'Takip No',
    trackingPlaceholder: 'Takip numarası',
    cost: 'Kargo Bedeli',
    costPlaceholder: '0,00',
    shippedAt: 'Gönderim Tarihi',
    expectedAt: 'Beklenen Teslim',
    expectedHint: 'Bu tarih geçerse kargo "Gecikti" olarak işaretlenir.',
    deliveredAt: 'Teslim Tarihi',
    partyPlaceholder: 'Ad soyad veya firma',
    partyOrg: 'Kurum / Merkez',
    partyOrgPlaceholder: 'Hastane, tedarikçi...',
    partyPhone: 'Telefon',
    partyPhonePlaceholder: '05xx xxx xx xx',
    addressPlaceholder: 'Adres',
    note: 'Not',
    notePlaceholder: 'Eklemek istediğiniz not',
    cancel: 'Vazgeç',
    save: 'Kaydet',
    update: 'Güncelle',
    saving: 'Kaydediliyor...',
    errors: {
      subject: 'Konu başlığı zorunludur',
      party: '{{party}} zorunludur',
      carrier: 'Kargo yola çıktıysa firma seçin',
      cost: 'Geçerli bir tutar girin (örn. 125,50)',
      items: 'Seçilen her stok için adet girin',
    },
  },
  items: {
    hint: {
      incoming: 'Kargo "Teslim Alındı" olduğunda bu kalemler stoğa eklenir.',
      outgoing: 'Kargo "Kargoya Verildi" olduğunda bu kalemler stoktan düşülür.',
    },
    empty: 'Stok kalemi eklenmedi. Kargo stoktaki bir malzemeyi taşıyorsa ekleyin; taşımıyorsa bu bölümü boş bırakabilirsiniz.',
    stock: 'Stok',
    stockPlaceholder: 'Stok seçin...',
    option: '{{name}} (kalan: {{remaining}})',
    quantity: 'Adet',
    remove: 'Kalemi kaldır',
    add: 'Stok kalemi ekle',
  },
  files: {
    drop: 'Kargo fişi, irsaliye veya tutanağı sürükleyin ya da tıklayın',
    uploading: 'Yükleniyor...',
    dropHint: 'PDF, görsel, Word veya Excel · en fazla 10 MB',
    remove: 'Dosyayı sil',
  },
  detail: {
    label: 'Kargo ayrıntıları',
    close: 'Kapat',
    trackingNo: 'Takip No',
    copy: 'Takip numarasını kopyala',
    query: 'Sorgula',
    phone: 'Telefon',
    carrier: 'Kargo Firması',
    shipped: 'Gönderim',
    expected: 'Beklenen Teslim',
    delivered: 'Teslim',
    cost: 'Kargo Bedeli',
    owner: 'Kaydı Açan',
    note: 'Not',
    info: 'Bilgiler',
    items: 'Stok Kalemleri',
    applied: 'Stoğa işlendi',
    notApplied: 'Henüz stoğa işlenmedi',
    files: 'Dosyalar',
    history: 'Geçmiş',
    quickStatus: 'Durumu güncelle',
    quickStatusHint: 'Kargo ilerledikçe yeni durumu seçin; tarih ve stok kendiliğinden güncellenir.',
    delete: 'Sil',
    edit: 'Düzenle',
  },
  access: {
    title: 'Kargo Yetkileri',
    subtitle: 'Kargo gönderip alabilecek çalışanlar',
    help: 'Anahtarı açık olan çalışanlar, profillerindeki Kargolarım sekmesinden kargo gönderip teslim alabilir.',
    granted_one: '{{count}} kişi yetkili',
    granted_other: '{{count}} kişi yetkili',
    search: 'Çalışan ara...',
    loading: 'Çalışanlar yükleniyor',
    empty: 'Eşleşen çalışan bulunamadı.',
    admin: 'Yönetici',
    adminHint: 'Yöneticiler her zaman yetkilidir',
    toggle: '{{name}} kargo yetkisi',
    saved: 'Her değişiklik anında kaydedilir.',
  },
};

export default cargo;
